import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowForwardIos from '@material-ui/icons/NavigateNext';
import { numberFormatter } from '../../../utility/common';
import { getKeywordDificultyColorRange } from '../../../utility/services/keywordHelper';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function Row(props) {
  const { cluster, name, parent_classes, isSingleLevel, keyName } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();

  //   Object.keys(cluster).filter(key => typeof cluster[key] !== "object")
  const keys = isSingleLevel
    ? Object.keys(cluster).filter((i) => i !== keyName)
    : ['search volume', 'keyword difficulty'];

  return (
    <React.Fragment>
      <TableRow className={`${parent_classes.tableRow} ${classes.root}`}>
        <TableCell className={parent_classes.tableCell}>
          {!isSingleLevel ? (
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowDownIcon /> : <ArrowForwardIos />}
            </IconButton>
          ) : null}
        </TableCell>
        <TableCell className={parent_classes.tableCell} scope="row">
          {name}
        </TableCell>
        {keys.map((key, index) => (
          <TableCell className={parent_classes.tableCell} key={index}>
            <span className="keyword-difficulty-score-circle">
              {typeof cluster[key] == 'number' ? numberFormatter(cluster[key]) : cluster[key] || '--'}
              {key === 'keyword difficulty' &&
                (cluster[key] ? (
                  <p
                    className="m-0"
                    style={{
                      width: '15px',
                      height: '15px',
                      borderRadius: '15px',
                      background: getKeywordDificultyColorRange(cluster[key] || 0),
                    }}
                  ></p>
                ) : null)}
            </span>
          </TableCell>
        ))}
      </TableRow>
      {name &&
        Object.keys(cluster)
          .filter((key) => typeof cluster[key] === 'object')
          .map((subName, index) => (
            <TableRow key={index} className={`${parent_classes.tableRow} ${classes.root}`}>
              {open && (
                <>
                  <TableCell className={parent_classes.tableCell} />
                  <TableCell className={parent_classes.tableCell} scope="row">
                    {subName}
                  </TableCell>
                  {keys.map((key, index) => (
                    <TableCell className={parent_classes.tableCell} key={index}>
                      <span className="keyword-difficulty-score-circle">
                        {typeof cluster[subName][key] == 'number'
                          ? numberFormatter(cluster[subName][key])
                          : cluster[subName][key] || '--'}
                        {key === 'keyword difficulty' &&
                          (cluster[subName][key] ? (
                            <p
                              className="m-0"
                              style={{
                                width: '15px',
                                height: '15px',
                                borderRadius: '15px',
                                background: getKeywordDificultyColorRange(cluster[subName][key] || 0),
                              }}
                            ></p>
                          ) : null)}
                      </span>
                    </TableCell>
                  ))}
                </>
              )}
            </TableRow>
          ))}
    </React.Fragment>
  );
}

Row.propTypes = {
  name: PropTypes.string.isRequired,
  cluster: PropTypes.object.isRequired,
  parent_classes: PropTypes.any,
  isSingleLevel: PropTypes.bool,
  keyName: PropTypes.string,
};

interface CollapsibleTableProps {
  data: any;
  isSingleLevel?: boolean;
  classes: any;
  keyName?: string;
  columns?: any;
}
const CollapsibleTable: React.FC<CollapsibleTableProps> = ({ data, isSingleLevel, classes, keyName, columns }) => {
  return (
    <TableContainer component={Paper} className={classes.tableWrap}>
      <Table aria-label="collapsible table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableHead} width={'32px'} />
            {(
              columns || [
                { name: 'Keyword Cluster' },
                { name: 'Avg. Search Volume', width: '95px' },
                { name: 'Keyword Difficulty', width: '81px' },
              ]
            ).map((i) => (
              <TableCell key={i.name} className={classes.tableHead} width={i.width}>
                {i.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.clusters ? (
            Array.isArray(data.clusters) && keyName ? (
              data.clusters.map((obj) => (
                <Row
                  key={obj[keyName]}
                  keyName={keyName}
                  name={obj[keyName]}
                  parent_classes={classes}
                  cluster={obj}
                  isSingleLevel={isSingleLevel}
                />
              ))
            ) : (
              Object.keys(data.clusters).map((name) => (
                <Row
                  key={name}
                  name={name}
                  parent_classes={classes}
                  cluster={data.clusters[name]}
                  isSingleLevel={isSingleLevel}
                />
              ))
            )
          ) : (
            <>No Data</>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

CollapsibleTable.propTypes = {
  data: PropTypes.object.isRequired,
};

export default CollapsibleTable;
